import SKUUploadTemplateQueries from './SKUUploadTemplateQueries'

const skus = {
  skus: {
    ...SKUUploadTemplateQueries,
  }
}

export default skus